import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from 'react-intl';
import {Link} from 'react-router-dom';

import {
  Wrapper,
  Overlay,
  Background,
  PanelContent,
  Logo,
  H1,
  HomeBody,
  OrderNow,
  Arrow
} from './LandingPanel.style';
import arrowIcon from '../../assets/icons/arrow.svg';
import {SpecialOffer} from './SpecialOffer';

class LandingPanel extends PureComponent {
  constructor(props) {
    super(props);
    this.scrollDown = this.scrollDown.bind(this);
    this.setRef = this.setRef.bind(this);
  }

  setRef(el) {
    this.wrapper = el;
  }

  scrollDown() {
    this.props.scrollDown(this.wrapper.clientHeight || 0);
  }

  render() {
    const {
      restaurant,
      OrderButtonText,
      firstColor,
      secondColor,
      backgroundImages,
      navUrls
    } = this.props;
    const isTemplateLight = restaurant && restaurant.template && restaurant.template.light;

    const renderHomeTitle = isTemplateLight &&
      restaurant.template.light.titleUnderLogo &&
      <H1>{restaurant.template.light.homeTitle}</H1>;

    const renderHomeBody = isTemplateLight &&
    restaurant.template.light.homeBody
      ? restaurant.template.light.homeBody
      : restaurant.address.singleLine;
    const promotions = restaurant && restaurant.content && restaurant.content.promotions;
    const renderPromotion = promotions && (promotions.menuPage || (promotions.message && promotions.message.length > 0)) && (
      <SpecialOffer promotions={promotions} />
    );
    return (
      <Wrapper innerRef={this.setRef}>
        <Arrow
          src={arrowIcon}
          onClick={this.scrollDown}
        />
        <PanelContent
          firstColor={firstColor}
          secondColor={secondColor}
        >
          <Logo
            src={`${restaurant.imageLogoUrl}=h300`}
            alt="restaurant logo"
            data-rw="home-page--light--restaurant-logo"
          />
          {renderHomeTitle}
          <HomeBody>{renderHomeBody}</HomeBody>
          {renderPromotion}
          <Link to={navUrls.menuUrl}>
            <OrderNow>
              <FormattedMessage id={OrderButtonText} />
            </OrderNow>
          </Link>
        </PanelContent>
        <Overlay />
        <div className="backgroundImage">
          <Background
            backgroundImages={backgroundImages}
          />
        </div>
      </Wrapper>
    );
  }
}

LandingPanel.propTypes = {
  restaurant: PropTypes.object.isRequired,
  headerColor: PropTypes.string,
  OrderButtonText: PropTypes.string,
  firstColor: PropTypes.string,
  secondColor: PropTypes.string,
  backgroundImages: PropTypes.object.isRequired,
  scrollDown: PropTypes.func.isRequired,
  navUrls: PropTypes.object
};

export default LandingPanel;



// WEBPACK FOOTER //
// ./containers/LightHomePage/LandingPanel.js